/* eslint-disable max-len */
/* eslint no-confusing-arrow: ["error", {allowParens: true}] */

import styled from 'styled-components';

import {
    Button,
    Card,
    Text,
    spaceMixin,
    token,
} from '@zillow/constellation';

import MediumIllustrationHouse2x from 'app/shared/images/MediumIllustrationHouse@2x.png';

const borderRadius = '4px';

export const StyledCard = styled(Card)`
    /* override */
    border-bottom: none;
    box-shadow: none;

    border: 1px solid ${token('colors.gray200')};
    padding: ${spaceMixin('sm')};
`;

export const StyledPhotoAddressContainer = styled.div`
    margin-bottom: ${spaceMixin('xs')};
    box-sizing: border-box;
    cursor: pointer;
`;

export const StyledPropertyPhotoContainer = styled.div`
    position: relative;
    padding: ${spaceMixin('xs')};
    width: 100%;
    height: 200px;

    background-repeat: no-repeat;
    background-position: center center;
    background-size: ${props => (props.primaryPhotoUrl ? 'cover' : '160px')};
    background-image: url(${props => (props.primaryPhotoUrl ? props.primaryPhotoUrl : MediumIllustrationHouse2x)});
    background-color: ${props => (props.primaryPhotoUrl ? '#888' : token('colors.blue200'))};

    border-radius: ${borderRadius};
`;

export const StyledAddressContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 2;
    margin-right: 10px;
    overflow: hidden;
    white-space: nowrap;

    > * {
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const StyledButton = styled(Button)`
    align-self: center;
    margin: 0 auto;
    min-width: 88px;
    overflow: hidden;
    text-overflow: ellipsis;

    /* constellation override to match design */
    padding: 5px 16px;
    white-space: nowrap;
`;

export const StyledPropertyPanelContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledRamp = styled.div`
    position: absolute;
    padding: 16px;
    width: 100%;
    height: 50%;
    bottom: 0;
    left: 0;
    color: white;
    border-radius: 0 0 ${borderRadius} ${borderRadius};

    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.75) 93%);
`;

export const StyledAddressAndCTAContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    margin-top: 22px;
`;

export const StyledStreetText = styled(Text)`
    margin-bottom: 2px;
    color: ${token('colors.white')};
    font-size: 20px;
`;

export const StyledCityStateZipText = styled(Text)`
    color: ${token('colors.white')};
    letter-spacing: 0.2px;
`;
